import { Resource } from '@redge-media/fo-js-sdk';
import Section from './section';

const CatalogSection = Resource.extend({
  constructor: function CatalogSection({ id }) {
    Resource.call(this);
    this.id = id;
    this.recordClass = Section;
  },

  getPath(method, opts) {
    if (opts.query && this.id) {
      return `/products/sections/${this.id}?${opts.query}`;
    }

    return `/products/sections/${this.id}`;
  },
});

export default CatalogSection;
